import React, { useEffect } from 'react';
import { Config } from '@leverege/plugin';
import { DataSources, Variantizers, ValueText } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
import { BlueprintDataSource } from '@leverege/molten-core';
import Util from "../Util.js";
import RelationshipUtil from "./RelationshipUtil.js";
import RelationshipSelector from "./RelationshipSelector.js"; // import ParentSelector from './ParentSelector'
// import ParentUtil from './ParentUtil'
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.imagine.attributes.RelationshipEditor');
const EMPTY = {};
const opts = {
  table: {
    isRenderer: true,
    blockChildren: false
  },
  detail: {
    isRenderer: true
  },
  form: {
    isRenderer: true,
    blockChildren: false
  }
};
export default {
  valueType: 'relationship',
  getOptions: usage => {
    return Config.get('RelationshipEditor', usage, opts[usage]);
  },
  create: opts => {
    return /*#__PURE__*/_jsx(RelationshipLoaderWrapper, {
      ...opts
    }, "loader");
  }
};
function RelationshipLoaderWrapper(props) {
  const {
    usage,
    attribute,
    object,
    context,
    onChange,
    value: pValue,
    title,
    editable,
    eventData
  } = props;
  const {
    relationship
  } = BlueprintDataSource.getRelationship(object) || EMPTY;
  const delegate = DataSources.getDelegate(object);
  const groupDelegate = RelationshipUtil.getGroupDelegate(object, attribute);
  const variant = Util.getAttributeRendererValueVariant(context?.renderer);
  const textVariant = Variantizers.getVariant(variant, object, context);
  const value = pValue?.childRef?.id || pValue;
  const val = value && groupDelegate ? groupDelegate.item(value).getItem()?.id : null;
  const isDone = value && groupDelegate ? groupDelegate.item(value).getItem()?.id : true;
  useEffect(() => {
    const getData = async () => {
      if (value === undefined) {
        // if ( attribute.source?.attribute?.path && !isDone ) {
        //   await GlobalState.dispatch( delegate.child( attribute.source.attribute.path ).get() )
        // }
      } else if (value && groupDelegate) {
        await GlobalState.dispatch(groupDelegate.item(value).get());
      }
    };
    getData();
  }, [value, isDone]);
  return delegate == null || groupDelegate == null ? /*#__PURE__*/_jsx(ValueText, {
    children: value || t('notConfigured')
  }) : /*#__PURE__*/_jsx(RelationshipSelector, {
    delegate: delegate,
    textVariant: textVariant,
    editable: editable,
    usage: usage,
    attribute: attribute,
    onChange: onChange,
    groupDelegate: groupDelegate,
    relationship: relationship,
    eventData: eventData,
    value: val,
    title: title,
    showFilter: true
  });
}